import { RosterDashboardListComponent } from './directives/roster-dashboard-list/roster-dashboard-list.component';
import { RosterDashboardRequestComponent } from './directives/roster-dashboard-request/roster-dashboard-request.component';
import { RosterDashboardEmployeeComponent } from './directives/roster-dashboard-employee/roster-dashboard-employee.component'
import { RosterDashboardSummaryComponent } from './directives/roster-dashboard-summary/roster-dashboard-summary.component'
import { RosterDashboardMapComponent } from './directives/roster-dashboard-map/roster-dashboard-map.component';
import { RosterDashboardVehicleComponent } from './directives/roster-dashboard-vehicle/roster-dashboard-vehicle.component'
import { RosterDashboardComponent } from './roster-dashboard.component';
import { RosterDispatchViewerComponent } from './directives/roster-dispatch-viewer/roster-dispatch-viewer.component';
import { RosterDashboardTripLogsComponent } from './directives/roster-dashboard-trip-logs/roster-dashboard-trip-logs.component';
import { RosterSummaryComponent } from './directives/roster-summary/roster-summary.component';
export const RosterDashboardDeclaration = [
    RosterDashboardComponent,

    //directives
    RosterDashboardListComponent,
    RosterDashboardRequestComponent,
    RosterDashboardEmployeeComponent,
    RosterDashboardSummaryComponent,
    RosterDashboardMapComponent,
    RosterDashboardVehicleComponent,
    RosterDashboardEmployeeComponent,
    RosterDispatchViewerComponent,
    RosterDashboardTripLogsComponent,
    RosterSummaryComponent
];